import { NestedTagNode } from 'base/webflow/schema';
import React from 'react';
import { cdnifyAssetUrls } from './styles';

export function transformNodeAttr(
  original: NestedTagNode['data']['attr'] = {},
) {
  const attrs: React.AllHTMLAttributes<unknown> = {};
  for (const [attr, value] of Object.entries(original)) {
    if (IGNORE_WEBFLOW_ATTRS.includes(attr)) continue;
    if (attr.startsWith('data-')) {
      // Pass through data- attributes without any transformation.
      (attrs as any)[attr] = value;
    } else if (attr === 'id') {
      // IDs are used for ix2.  We don't implement ix2 so we don't need them.
      // IDs aren't guaranteed to be unique we render multiple ElementInstances
      //   in 1 component renderer (the "slotOverrides" feature).
      continue;
    } else if (attr === 'src') {
      attrs.src = cdnifyAssetUrls(value);
      continue;
    } else if (attr === 'loading') {
      // not included in AllHTMLAttributes ;(
      (attrs as React.ImgHTMLAttributes<unknown>).loading = value;
      continue;
    } else {
      const pname = PASSTHROUGH_ATTRS[attr as keyof typeof PASSTHROUGH_ATTRS];
      if (!pname) {
        if (!hasWarnedAbout.has(attr)) {
          hasWarnedAbout.add(attr);
          console.warn('Unsupported node attr - ignoring', attr, value);
        }
        (attrs as any)[attr] = value;
        continue;
      }
      attrs[pname] = value;
    }
  }
  return attrs;
}

// You can run this command over our component library:
//   cat **/*.json | jq '.payload.nodes[] | .data.attr | select(. != null) | keys[]' -r | sort | uniq -c | sort -nr
// Any attribute with special handling is not added to this list
const PASSTHROUGH_ATTRS = {
  id: 'id',
  width: 'width',
  src: 'src',
  height: 'height',
  href: 'href',
  name: 'name',
  type: 'type',
  required: 'required',
  placeholder: 'placeholder',
  maxlength: 'maxLength',
  autofocus: 'autoFocus',
  disabled: 'disabled',
  value: 'value',
  action: 'action',
  method: 'method',
  for: 'htmlFor',
  checked: 'checked',
  role: 'role',
  multiple: 'multiple',
  title: 'title',
  start: 'start',
} as const satisfies Record<string, keyof React.AllHTMLAttributes<unknown>>;

const IGNORE_WEBFLOW_ATTRS = [
  // might break out app
  'autofocus',
  // a non-html attribute for use in forms
  'redirect',
];

const hasWarnedAbout = new Set<string>();
